// IMPORT BASE-MODULE
import BaseModule from '@core/modules/base-module/base-module';
import $ from 'jquery';
import TeaserCardWithLinks from '@core/components/cards/teaser-card-with-links/teaser-card-with-links';

const teasersGroup = new BaseModule();
teasersGroup.name = 'teasers-group';
teasersGroup.init(that => {
  that.elements.each((i, e) => {
    const teaserCard = new TeaserCardWithLinks($(e));
    teaserCard.init();
  });
});
